var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9994 0.666016C15.5993 0.666016 0.666016 15.5993 0.666016 33.9994C0.666016 52.3994 15.5993 67.3327 33.9994 67.3327C52.3994 67.3327 67.3327 52.3994 67.3327 33.9994C67.3327 15.5993 52.3994 0.666016 33.9994 0.666016ZM33.9994 60.666C19.2994 60.666 7.33268 48.6994 7.33268 33.9994C7.33268 19.2994 19.2994 7.33268 33.9994 7.33268C48.6994 7.33268 60.666 19.2994 60.666 33.9994C60.666 48.6994 48.6994 60.666 33.9994 60.666ZM49.2994 19.266L27.3327 41.2327L18.6993 32.6327L13.9993 37.3327L27.3327 50.666L53.9994 23.9993L49.2994 19.266Z",
    fill: "#16B27E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.dfb3a9caac639cb9ca90dd7ac27290ba.svg";
export { ForwardRef as ReactComponent };